import { CpmBidColumn as CpmBidColumnConfig } from '@bingads-webui-campaign/ad-groups-data';
import { BidBaseColumn, commonBidStrategyListToDisableBidAmountEdit } from './bid-base-column';

export class CpmBidColumn extends BidBaseColumn {
  constructor({ i18n, view, isForVNext }) {
    super({
      ...CpmBidColumnConfig,
      title: i18n.getString('ColumnName_CpmBid'),
      i18n,
      view,
      bidStrategyListToDisableBidAmountEdit: commonBidStrategyListToDisableBidAmountEdit(['ManualCpm']),
      isForVNext,
    });
  }
}
